import React, { useEffect, useState } from "react"
import useIntersectionObserver from "../../hooks/useIntersectionObserver"
import StarBadge from "../../svg/star-badge.inline.svg"

import {
  Container,
  Badge,
  BadgeTitle,
  StarBadgeContainer,
  SecretEmailLink,
  Form,
  Label,
  FormElement,
  Textarea,
  Button,
} from "./styles"

const Contact = ({ visible }) => {
  const [ref, containerEntry] = useIntersectionObserver({ threshold: 0.432 })
  const [formValues, setFormValues] = useState({
    yesproblem: "",
    noproblem: "",
    budget: "",
  })

  useEffect(() => {
    if (containerEntry.isIntersecting) {
      document.documentElement.style.setProperty("--color-yes", "white")
    } else {
      document.documentElement.style.setProperty("--color-yes", "blue")
    }
  }, [containerEntry.isIntersecting])

  function onSubmit(e) {
    e.preventDefault()

    const email = "yes@problem.studio"

    const subject = "I has problem"

    const body = `yesproblem: ${formValues.yesproblem}%0D%0A%0D%0Anoproblem: ${formValues.noproblem}%0D%0A%0D%0Abudget: ${formValues.budget}%0D%0A%0D%0A`

    const link = `mailto:${email}?subject=${subject}&body=${body}`

    window.open(link, "emailWindow")
  }

  function onChange(e) {
    const { value, name } = e.target

    setFormValues({
      ...formValues,
      [name]: value,
    })
  }

  return (
    <Container ref={ref} style={{ display: visible ? "block" : "none" }}>
      <Badge>
        <BadgeTitle>You Ask We Code</BadgeTitle>
        <StarBadgeContainer>
          <StarBadge style={{ width: "100%", color: "var(--white)" }} />
        </StarBadgeContainer>
      </Badge>

      <SecretEmailLink>
        <a
          href="mailto:yes@problem.studio"
          target="_blank"
          rel="noopener noreferrer"
        >
          secret email link
        </a>
      </SecretEmailLink>

      <Form onSubmit={onSubmit}>
        <FormElement>
          <Label htmlFor="yesproblem">yesproblem:</Label>
          <Textarea
            name="yesproblem"
            id="yesproblem"
            placeholder="Explain the (yes)problem"
            rows="6"
            onChange={onChange}
            value={formValues["yesproblem"]}
          />
        </FormElement>

        <FormElement>
          <Label htmlFor="noproblem">noproblem</Label>
          <Textarea
            name="noproblem"
            id="noproblem"
            placeholder="Explain when it's no problem"
            rows="6"
            onChange={onChange}
            value={formValues["noproblem"]}
          />
        </FormElement>

        <FormElement>
          <Label htmlFor="budget">budget</Label>
          <Textarea
            name="budget"
            id="budget"
            placeholder="Because Rou Hun wants to travel and Sander needs to buy expensive hipster coffee"
            rows="6"
            onChange={onChange}
            value={formValues["budget"]}
          />
        </FormElement>

        <Button>Send!</Button>
      </Form>
    </Container>
  )
}

export default Contact
